<div class="accordion" id="accordionExample" style="margin-top: -30px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Aanmerkelijk belang
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je hebt een aanmerkelijk belang als je, eventueel samen met je fiscale partner, direct of indirect
                <b>minimaal 5%</b> hebt van:
                <li class="list">de aandelen (ook per soort) in een binnen- of buitenlandse vennootschap</li>
                <li class="list">de winstbewijzen van een binnen- of buitenlandse vennootschap</li>
                <li class="list">een recht van vruchtgebruik op de aandelen (ook per soort) in een binnen- of
                    buitenlandse
                    vennootschap
                </li>
                <li class="list">een recht van vruchtgebruik op de winstbewijzen van een binnen- of buitenlandse
                    vennootschap
                </li>
                <li class="list">het stemrecht in een coöperatie of vereniging op coöperatieve grondslag</li>
                <div class="space10"></div>

                <b>Opties</b><br/>
                Je hebt ook een aanmerkelijk belang als u, eventueel samen met je fiscale partner, opties hebt om
                minimaal 5% van de aandelen (ook per soort) in een binnen- of buitenlandse vennootschap te verwerven.
                <div class="space10"></div>

                <b>Bewijs van een deelgerechtigdheid</b><br/>
                Een bewijs van een deelgerechtigdheid in een zogenaamd 'open fonds voor gemene rekening' geldt ook als
                aandeel in een vennootschap. Het gaat dan om fondsen die ervoor zorgen dat deelgerechtigden voordelen
                krijgen door het aanwenden van geld, bijvoorbeeld door over gezamenlijke rekeningen te beleggen. Deze
                beleggingsfondsen hebben verhandelbare bewijzen van deelgerechtigdheid. Dit kan een binnen- of
                buitenlands fonds
                <div class="space10"></div>

                <b>Familieleden met aanmerkelijk belang</b><br/>
                Heeft 1 van je familieleden een aanmerkelijk belang in een vennootschap of coöperatie? En heb je ook
                aandelen, opties, winstbewijzen of lidmaatschapsrechten in deze vennootschap of coöperatie? Dan heb je
                ook een aanmerkelijk belang voor úw aandelen, opties, winstbewijzen of lidmaatschapsrechten in die
                vennootschap of coöperatie. Het gaat hier om familieleden in de rechte lijn, zoals ouders, grootouders,
                kinderen, kleinkinderen van uzelf of van je fiscale partner, en de fiscale partners van deze
                familieleden.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Reguliere voordelen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Reguliere voordelen uit aanmerkelijk belang zijn bijvoorbeeld:

                <li class="list">dividenden en andere winstuitkeringen</li>
                <li class="list">het vaste rendement van een (buitenlandse) beleggingsinstelling</li>
                <div class="space10"></div>

                Vul de bruto-inkomsten in. Dit zijn de inkomsten zonder aftrek van kosten of eventueel ingehouden
                (dividend)belasting.
                <div class="space10"></div>

                <b>Geen regulier voordeel</b><br/>
                Heb je rente uit schuldvorderingen op een vennootschap waarin je een aanmerkelijk belang had? Dan is dit
                geen regulier voordeel. Deze rente geef je aan als 'Overige inkomsten -
                Terbeschikkingstellingsregeling'.
                <div class="space10"></div>

                <b>Van wie reguliere voordelen invullen? </b><br/>
                Je geeft de reguliere voordelen aan van:
                <li class="list">jezelf</li>
                <li class="list">je fiscale partner</li>
                <li class="list">je minderjarige kinderen</li>
                <li class="list">de minderjarige kinderen van je fiscale partner</li>
                <div class="space10"></div>

                Had je een deel van het jaar een fiscale partner? Dan hoef je de reguliere voordelen van (de
                minderjarige kinderen van) je fiscale partner alleen aan te geven als je ervoor kiest om
                heel {{ this.year }} fiscale partners te zijn.
                <div class="space10"></div>

                Werd je kind in {{ this.year }} meerderjarig? Geef dan de voordelen van het kind aan tot het moment
                waarop het meerderjarig werd.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading11">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
                Fictieve reguliere voordelen bij excessief lenen
            </button>
        </h2>
        <div id="collapse11" class="accordion-collapse collapse" aria-labelledby="heading11"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Excessief lenen van bv beperkt vanaf 2023</b><br/>
                Leen je, of lenen jij en je fiscale partner meer dan een drempelbedrag (2024/2025/2026: € 500.000, 2023: €
                700.000) van je bv? Dan wordt het meerdere belast als inkomsten uit aanmerkelijk belang (box 2).
                <div class="space10"></div>

                <b>Schulden en vorderingen</b><br/>
                Om de hoogte van de lening vast te stellen, tellen alle schulden aan je bv mee, behalve de
                eigenwoningschulden. Hiervoor geldt dat er wel een recht van hypotheek moet zijn ten gunste van de bv.
                Deze voorwaarde geldt niet als de eigenwoningschuld al bestond op 31 december 2022.
                <div class="space10"></div>

                Alleen je schulden tellen mee. De Belastingdienst houdt geen rekening met eventuele vorderingen die je
                hebt op je bv.
                <div class="space10"></div>

                Heb je schulden bij meerdere bv’s? Dan worden deze schulden bij elkaar opgeteld.
                <div class="space10"></div>

                Niet alleen je eigen bovenmatige schulden worden meegeteld. Ook die van je fiscale partner en verbonden
                personen. Verbonden personen zijn de bloed- of aanverwanten in de rechte lijn van jezelf of van je
                partner, bijvoorbeeld een kind. Het maakt niet uit wie de schulden bij de eigen vennootschap is
                aangegaan. Voor de verbonden personen geldt wel een eigen drempel.
                <div class="space10"></div>

                Heb je eerder met de Belastingdienst afspraken gemaakt over schulden bij je bv? Dan kan het zijn dat
                deze afspraken
                vervallen als het totaal van de schulden meer is dan het drempelbedrag (2024/2025/2026: € 500.000, 2023: €
                700.000).
                <div class="space10"></div>

                <b>Drempel</b><br/>
                De drempel voor een lening van je bv is € 500.000 (2023: € 700.000). Leen je in een jaar meer dan de
                drempel? Dan wordt het meerdere het jaar erna opgeteld bij de drempel voor dat jaar.
                <div class="space10"></div>

                Los je een deel van de lening af? Dan daalt de drempel met dat bedrag, tot minimaal het drempelbedrag
                (2024/2025/2026: € 500.000 , 2023: € 700.000).
                <div class="space10"></div>

                Ondanks dat een deel van de lening mogelijk wordt belast als inkomsten uit aanmerkelijk belang (box 2)
                blijft de lening in zijn geheel bestaan. Dat betekent dat de bv rente in rekening moet blijven brengen
                over de hele lening. Over alle ontvangen rente betaalt zij vennootschapsbelasting. Ook andere zakelijke
                voorwaarden van de lening blijven in stand. Bijvoorbeeld het rentepercentage, de aflossing en de
                vastgelegde zekerheden.
                <div class="space10"></div>

                De bv hoeft geen dividendbelasting in te houden over het deel van de lening dat is belast als inkomsten
                uit aanmerkelijk belang.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Eerder belaste fictieve reguliere voordelen bij excessief lenen
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het saldo fictief regulier voordeel vóór {{ year }} betreft het fictief regulier voordeel {{ year - 1 }}
                . Dit vind je terug in uw aangifte inkomstenbelasting {{ year - 1 }}. Vul dat bedrag in.
                <div class="space10"></div>

                <b>Ging de partners in {{ year - 1 }} uit elkaar en zijn ze niet langer fiscale partners?</b><br/>
                Wat je moet invullen hangt ervan af of je in {{ year - 1 }} koos om fiscale partners te zijn voor het
                hele jaar.
                <div class="space10"></div>

                <b>Je koos ervoor heel {{ year - 1 }} fiscale partners te zijn</b><br/>
                Koos je ervoor om in {{ year - 1 }} het hele jaar fiscale partners te zijn, dan is het saldo fictief
                regulier voordeel vóór {{ year }} zowel van aangever als van de ex-partner. Je verdeelt het saldo
                fictief
                regulier voordeel vóór {{ year }} naar keuze tussen aangever en de ex-partner.<br/>
                <u>Voorbeeld</u><br/>
                Je had op 31 december {{ year - 1 }} een schuld aan de vennootschap van € 800.000. In {{ year - 1 }} was
                het fictief regulier voordeel € 100.000. Aangever en ex-partner kiezen ervoor om dit fictief regulier
                voordeel in gelijke delen
                te verdelen. Je vult dan € 50.000 in. De ex-partner doet hetzelfde in de eigen aangifte.
                <div class="space10"></div>
                Het maakt niet uit wie de aandelen of de schuld had, of aan wie de aandelen of de schuld is toebedeeld
                bij het einde van de partnerschap.

                <div class="space10"></div>
                <b>Je koos er niet voor heel {{ year - 1 }} fiscale partners te zijn</b><br/>
                Als je er in {{ year - 1 }} niet voor koos om het hele jaar fiscale partner te zijn, dan is het saldo
                fictief regulier voordeel vóór {{ year }} volledig je eigen saldo. Dit bedrag vul je in.
                <div class="space10"></div>
                Let op!<br/>
                De verdeling van het saldo fictief regulier voordeel vóór {{ year }} tussen aangever en de ex-partner,
                moet opgeteld altijd 100% zijn.
                <div class="space10"></div>
                <b>Gingen aangever en partner in {{ year }} uit elkaar en zijn ze niet langer fiscale partners?</b><br/>
                Wat je moet invullen hangt ervan af of je in {{ year }} kiest om fiscale partners te zijn voor het hele
                jaar.

                <div class="space10"></div>
                <b>Je kiest om heel {{ year }} fiscale partners te zijn</b><br/>
                Kies je ervoor om in {{ year }} het hele jaar fiscale partners te zijn, dan komt de verdeling van het
                saldo fictief regulier voordeel over {{ year - 1 }} en {{ year }} aan de orde in je aangifte en die van
                je ex-partner over {{ year + 1 }}.
                <div class="space10"></div>
                <b>Je kiest niet om heel {{ year }} fiscale partners te zijn</b><br/>
                Als je niet kiest om heel {{ year }} fiscale partners te zijn, en de ex-partner had direct na het einde
                van het fiscale partnerschap geen aanmerkelijk belang, dan wordt het saldo regulier voordeel volledig
                aan aangever toebedeeld. Je vult het volledige saldo in van het fictief regulier voordeel
                vóór {{ year }}.
                <div class="space10"></div>
                Had de ex-partner direct na het einde van het fiscale partnerschap wel een aanmerkelijk belang? Dan moet
                je het saldo fictief regulier voordeel onderling in gelijke delen tussen aangever en de ex-partner
                verdelen. Je geeft dan de helft aan van het gezamenlijke saldo fictief regulier voordeel.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Aftrekbare kosten inzake reguliere voordelen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De volgende vallen hieronder:
                <li class="list">rente en kosten voor leningen om aandelen, opties of winstbewijzen van het aanmerkelijk
                    belang te
                    kopen
                </li>
                <li class="list">kosten van de bank voor het beheer van aandelen</li>
                <div class="space10"></div>

                <b>Welke kosten vul je hier niet in?</b>
                <li class="list">vooruitbetaalde rente voor de periode na 31 december {{ this.year }} als het tijdvak
                    waarover de rente is berekend, eindigt na 30 juni {{ this.year + 1 }}. Deze rente mag je aftrekken
                    in het jaar waarop de rente betrekking heeft.
                <li class="list">rente en kosten van overbedelingsschulden bij verdeling van een erfenis volgens
                    ouderlijke boedelverdeling of bij een wettelijke verdeling
                <li class="list">ingehouden dividendbelasting. Nederlandse dividendbelasting geeft je aan als
                    'Ingehouden dividendbelasting'.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Vervreemdingsvoordelen
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je hebt vervreemdingsvoordelen als je aandelen, opties, winstbewijzen of lidmaatschapsrechten verkoopt
                die bij een aanmerkelijk belang horen. Het vervreemdingsvoordeel is de overdrachtsprijs min de
                verkrijgingsprijs.
                <div class="space10"></div>

                In bepaalde situaties behandelt de Belastingdienst je aandelen, opties, winstbewijzen of
                lidmaatschapsrechten alsof je ze verkoopt. Dit noemen we fictieve vervreemding. Bij fictieve
                vervreemding geldt als overdrachtsprijs of verkrijgingsprijs meestal de waarde in het economisch verkeer
                op dat moment.<br/>
                In de volgende situaties is er sprake van fictieve vervreemding:
                <li class="list">De vennootschap waarin je een aanmerkelijk belang hebt, krijgt de status van een
                    vrijgestelde
                    beleggingsinstelling (vbi) of het vermogen van de vennootschap wordt ondergebracht in een
                    buitenlands beleggingslichaam.
                </li>
                <li class="list">je doet je aandelen over aan een ander door erfrecht of huwelijksvermogensrecht.</li>
                <li class="list">je emigreert.</li>
                <li class="list">je brengt je aandelen onder bij je onderneming.</li>
                <li class="list">je hebt door verkoop, of doordat de aandelen van je ex-partner niet meer meetellen,
                    minder dan 5%
                    van de aandelen.
                </li>
                <li class="list">je ontvangt een liquidatie-uitkering.</li>
                <li class="list">je verleent een koopoptie op je aandelen, winstbewijzen of lidmaatschapsrechten.</li>
                <div class="space10"></div>

                <b>De overdrachtsprijs</b><br/>
                De overdrachtsprijs is het bedrag dat je krijgt als je aandelen, opties, winstbewijzen of
                lidmaatschapsrechten verkoopt. Het gaat om het nettobedrag, dat wil zeggen de overdrachtsprijs min
                eventuele overdrachtskosten, zoals verkoopkosten.
                <div class="space10"></div>

                <b>De verkrijgingsprijs</b><br/>
                De verkrijgingsprijs is het bedrag van aankoop of de waarde in het economisch verkeer op het moment
                dat je je aandelen, opties, winstbewijzen of lidmaatschapsrechten hebt gekregen. Ook de
                verkrijgingsprijs of de waarde in het economisch verkeer van een latere uitbreiding van je aanmerkelijk
                belang telt mee. Notariskosten mag je bij de verkrijgingsprijs tellen.
                <div class="space10"></div>

                In de volgende situaties geldt een andere waarde als verkrijgingsprijs:
                <li class="list">je erft een aanmerkelijk belang.</li>
                <li class="list">je krijgt een aanmerkelijk belang door schenking.</li>
                <li class="list">je aanmerkelijk belang ontstaat in de loop van het aangiftejaar.</li>
                <li class="list">je krijgt het aanmerkelijk belang voor een onzakelijke prijs.</li>
                Lees meer over deze situaties via 'Meer fiscale informatie' hieronder.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Verzoek doorschuiving verkrijgingsprijs
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                In een aantal gevallen mag je de winst over de vervreemding (het vervreemdingsvoordeel) doorschuiven
                naar een later tijdstip. Bijvoorbeeld bij schenken, erven en emigreren. Doorschuiven geldt bijvoorbeeld
                niet als de vennootschap waarin je een aanmerkelijk belang hebt de status krijgt van een vrijgestelde
                beleggingsinstelling (vbi) of het vermogen van de vennootschap wordt ondergebracht in een buitenlands
                beleggingslichaam.
                <div class="space10"></div>
                Voor het doorschuiven van de verkrijgingsprijs moet je een verzoek indienen bij de Belastingdienst.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Onderscheid ondernemings- en beleggingsvermogen
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De doorschuifregeling geldt enkel voor ondernemingsvermogen. Over het beleggingsvermogen moet worden
                afgerekend in box 2. Van het beleggingsvermogen mag overigens een klein deel als ondernemingsvermogen
                worden aangemerkt (= de zogenoemde beleggingsmarge, welke 5% van de waarde in het economische verkeer
                van het ondernemingsvermogen bedraagt).
                <div class="space20"></div>
                Om te beoordelen welke deel van de waarde van de aandelen is toe te rekenen aan het ondernemingsvermogen
                en welk deel aan het beleggingsvermogen zal op ieder vermogensbestanddeel van de B.V. (lees iedere
                balanspost) als het ware een etiket moeten worden geplakt met daarop ondernemingsvermogen of
                beleggingsvermogen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Verlies uit aanmerkelijk belang
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Is je inkomen uit aanmerkelijk belang negatief? Dan is er sprake van een te verrekenen verlies uit
                aanmerkelijk belang. Een verlies uit aanmerkelijk belang ontstaat als de verkrijgingsprijs van de
                aandelen hoger is dan de vervreemdingsprijs.
                <div class="space10"></div>

                <b>Verlies omzetten in belastingkorting</b><br/>
                Heb je geen aanmerkelijk belang meer, maar wel nog een onverrekend verlies uit aanmerkelijk belang? En
                wil je dit verlies omzetten in een belastingkorting? Stuur dan de Belastingdienst een brief waarin je
                hierom vraagt. De Belastingdienst stelt de belastingkorting vast in een beschikking. De korting is 26,9%
                van het onverrekende verlies en vermindert de belasting en premie volksverzekeringen in box 1. Deze
                belastingkorting kan in de jaren erna worden verrekend met de heffing van box 1. De verrekening met de
                heffing in box 1 vindt pas plaats in het 2e jaar nadat je geen aanmerkelijk belang meer hebt.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Verdeelpost
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Inkomen uit aanmerkelijk belang is een van de verdeelposten. Vul bij deze vraag dus zowel het inkomen
                uit aanmerkelijk belang in van de aangever als van de partner. Het maakt dus niet uit wie juridisch of
                economisch eigenaar is van de betreffende AB-aandelen.
                <div class="space10"></div>
                Bij het onderdeel 'Verdeling' kun je een (optimale) verdeling kiezen tussen de fiscaal partners.

            </div>
        </div>
    </div>


</div>


